module.exports = __webpack_public_path__ + "img/17-image-1-1@2x.731d2fd8.png";